var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHacken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6936 54V58.504H22.1734V54H19V66.3863H22.1734V61.8823H31.6936V66.3863H34.8671V54H31.6936Z",
    fill: "#AAAAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.633 54H161.806V66.3863H158.633V54Z",
    fill: "#AAAAB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.246 63.0079H136.418V66.3863H133.246V63.0079Z",
    fill: "#AAAAB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8165 61.8823H91.9899V66.3863H88.8165V61.8823Z",
    fill: "#AAAAB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9899 58.504L88.8165 61.8823H79.2962V66.3863H76.1228V54H79.2962V58.504H88.8165V54H91.9899V58.504Z",
    fill: "#AAAAB6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0405 54H53.9075V66.3863H50.7341V61.8823H41.2139V66.3863H38.0405V54ZM50.7341 57.3776H41.2139V58.504H50.7341V57.3776Z",
    fill: "#AAAAB6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9494 57.3776V54H57.0823V66.3863H72.9494V63.0079H60.2558V57.3776H72.9494Z",
    fill: "#AAAAB6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.03 54V57.3776H98.3367V58.504H111.03V61.8816H98.3367V63.0079H111.03V66.3863H95.1633V54H111.03Z",
    fill: "#AAAAB6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.899 54V61.8823L117.377 54H114.205V66.3863H117.377V58.504L126.899 66.3863H130.071V54H126.899Z",
    fill: "#AAAAB6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.766 54H155.46V66.3863H152.286V61.8823H142.766V66.3863H139.592V57.3776L142.766 54ZM142.766 58.504H152.286V57.3776H142.766V58.504Z",
    fill: "#AAAAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacken);
export default __webpack_public_path__ + "static/media/hacken.35d2974dc85f9734fddb60764d327ff2.svg";
export { ForwardRef as ReactComponent };